import React from 'react';
import { motion } from 'framer-motion';
import { PillarList } from './pillars/PillarList';
import { ncjiPillarsIntro } from '../data/pillars';
import { fadeUp } from '../utils/motion';

/** "What is assessed": NCJI's five pillars, shown on the HCF page. */
export function CapabilityDomains() {
  return <section id="pillars" className="scroll-mt-20 py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-96" data-mp="351ek91lbttni">
      <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12" data-id="element-97" data-mp="3sstq34cbat3i">
        <div className="lg:col-span-5" data-id="element-98" data-mp="1kehmga72b75">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-99" data-mp="1jd507dj5gnb">What is assessed · NCJI’s five pillars</p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark leading-tight" data-id="element-100" data-mp="3jt6lyas7796r">
            Five pillars of sound judgment.
          </h2>
        </div>
        <p className="lg:col-span-7 lg:pt-8 text-lg text-ink-muted leading-relaxed" data-id="element-101" data-mp="28b48lnv7lm4q">{ncjiPillarsIntro}</p>
      </motion.div>
      <PillarList data-id="element-102" data-mp="2d8xai4phbtz7" />
    </section>;
}